import React from 'react';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';

const NotFoundPage = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col">
          <h4><FormattedMessage id="404.title" /></h4>
          <Link to="/da_dk/showersystems/"><FormattedMessage id="404.link.goBack" /></Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/NotFoundPage.js